var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"60vh"}},[_c('div',{staticClass:"title",staticStyle:{"height":"10%"}},[_vm._v("D8 To-do list")]),_vm._v(" "),_c('div',{staticStyle:{"height":"90%","border":"1px solid #2c7be8"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.toStr)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cd4a5ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fr/8d/component/8d.vue
// module id = null
// module chunks = 